/* External */
import {
  useEffect,
  useCallback,
  useState,
} from 'react';

/* Utils */
import { fetchMoreLikeThisEPGService } from '../services/morelikethis';

export default function useFetchMoreLikeThisEpg({
  contentId,
  tryFetchAgain,
  isDisplaying,
}) {
  const [isFetchingEpg, setIsFetchingEpg] = useState(true);
  const [moreLikeThisItemsEpg, setMoreLikeThisItemsEpg] = useState([]);
  const [moreLikeThisTitleEpg, setMoreLikeThisTitleEpg] = useState('');
  const [errorEpg, setErrorEpg] = useState(undefined);

  const getMoreLikeThisEPG = useCallback(() => {
    setIsFetchingEpg(true);
    fetchMoreLikeThisEPGService(contentId).then((response) => {
      const { data: { contents, title } } = response;

      setMoreLikeThisItemsEpg(contents);
      setMoreLikeThisTitleEpg(title);
      setIsFetchingEpg(false);
      return true;
    }).catch((error) => {
      console.error('moreLikeThis>useFetchMoreLikeThisEpg', error);
      setErrorEpg(error);
      setIsFetchingEpg(false);
      return false;
    });
  }, [contentId]);

  useEffect(() => {
    if (contentId && isDisplaying) {
      getMoreLikeThisEPG();
    }
  }, [
    getMoreLikeThisEPG,
    contentId,
    isDisplaying,
    tryFetchAgain,
  ]);

  return {
    moreLikeThisItemsEpg,
    moreLikeThisTitleEpg,
    isFetchingEpg,
    errorEpg,
  };
}
